import { Flex, Text, Icon } from '@chakra-ui/react';
import React from 'react';

import { SelectedPipeline } from './SelectedPipeline';
import { FiCalendar } from 'react-icons/fi';

export const DateAndVersionInput = ({
  selectedPipeline,
  onClick,
  children,
}: {
  selectedPipeline: SelectedPipeline | null;
  onClick: () => void;
  children?: React.ReactNode;
}) => {
  const formatDate = (dateString: string) => {
    const [year, month, day] = dateString.split('-').map(Number);
    return new Date(year, month - 1, day);
  };

  const handleKeyDown = (event: React.KeyboardEvent): void => {
    // The element is rendered `as="button"`, so the browser already fires a
    // native click for Enter/Space — don't call onClick here or it double-fires.
    // We only suppress Space's default page-scroll.
    if (event.key === ' ') {
      event.preventDefault();
    }
  };

  return (
    <Flex
      as="button"
      type="button"
      aria-label="Change reporting date and version"
      borderWidth="1px"
      borderRadius="5px"
      padding="6px 16px"
      minHeight="40px"
      alignItems="center"
      cursor="pointer"
      transition="background 0.15s, border-color 0.15s"
      _hover={{ bg: 'blackAlpha.50', borderColor: 'gray.400' }}
      _focusVisible={{ boxShadow: 'outline', outline: 'none' }}
      onClick={onClick}
      onKeyDown={handleKeyDown}
    >
      <Icon as={FiCalendar} marginRight="10px" h="inherit" />
      {selectedPipeline ? (
        <Text>
          {`${formatDate(selectedPipeline.reportingDate).toLocaleDateString(
            undefined,
            {
              year: 'numeric',
              month: 'short',
              day: 'numeric',
            },
          )} - version ${selectedPipeline.fileVersion}`}
        </Text>
      ) : (
        <Text>Select Date and Version</Text>
      )}
      {children}
    </Flex>
  );
};
